import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  cancelRequestStart,
  cancelRequestSuccess,
  cancelRequestFailed,
} from "../redux/cancelRequest";
import { cancelRequestApi } from "core/http/service/timeKeeping";
import {
  selectCancelRequestData,
  selectReasonCancelRequest,
  startDateSelector,
} from "../redux/selector";
import { toast } from "react-toastify";
import { getListRequestLeaveStart } from "../redux/getListRequestLeave";
import { getListArriveLateStart } from "../redux/getListArriveLate";
import { getListFeedbackStart } from "../redux/getListFeedback";
import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { getPaidLeaveBalanceStart } from "../redux/getPaidLeaveBalance";
import { SCREEN } from "helper/roleChecker/Screens";
import { getTimeKeepingSummaryStart } from "../redux/getTimeKeepingSummary";
import moment from "moment";

function* cancelRequestWork(action) {
  const id = yield select(selectCancelRequestData);
  const reasonCancel = yield select(selectReasonCancelRequest);
  const startDate = yield select(startDateSelector);

  const { screenCode, tab, callback } = action.payload;

  try {
    yield call(cancelRequestApi, screenCode, id, reasonCancel, tab);

    yield put({
      type: cancelRequestSuccess.type,
    });
    toast.success("Đơn của bạn đã được hủy thành công");
    yield put({
      type: getPaidLeaveBalanceStart.type,
      payload: SCREEN.IP_015,
    });
    yield put({
      type: getTimeKeepingSummaryStart.type,
      payload: {
        year: moment().year(),
        month: moment().month() + 1,
        screenCode: SCREEN.IP_015,
      },
    });

    yield put({
      type:
        tab === "leave"
          ? getListRequestLeaveStart.type
          : tab === "late"
            ? getListArriveLateStart.type
            : getListFeedbackStart.type,
      payload: {
        screenCode: SCREEN.IP_016,
        year: startDate.year(),
        month: startDate.month() + 1,
        limit: 60,
        offset: 0,
      },
    });
    if (callback) {
      callback();
    }
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: cancelRequestFailed.type,
    });
  }
}

function* watchCancelRequest() {
  yield takeLatest(cancelRequestStart.type, cancelRequestWork);
}

export default function* cancelRequestSaga() {
  yield all([watchCancelRequest()]);
}
